/**
 * @module action-planning ui
 */
import { createReducer } from '@reduxjs/toolkit';
import { taskActions } from '~/behaviors/actions/task.actions';
import { taskTemplateActions } from '~/behaviors/actions/task_template.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';

const defaultState = {
  isLoadingTasks: false,
  isLoadingTaskTemplates: false,
};

const reset = () => defaultState;

const merge = (updates) => (state) => ({
  ...state,
  ...updates,
});

const actionPlanningUI = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(taskActions.fetchTaskList.pending, merge({ isLoadingTasks: true }));
  builder.addCase(taskActions.fetchTaskList.fulfilled, merge({ isLoadingTasks: false }));
  builder.addCase(taskActions.fetchTaskList.rejected, merge({ isLoadingTasks: false }));
  builder.addCase(taskTemplateActions.fetchTaskTemplateList.pending, merge({ isLoadingTaskTemplates: true }));
  builder.addCase(taskTemplateActions.fetchTaskTemplateList.fulfilled, merge({ isLoadingTaskTemplates: false }));
  builder.addCase(taskTemplateActions.fetchTaskTemplateList.rejected, merge({ isLoadingTaskTemplates: false }));
});

export default actionPlanningUI;
